import { render } from "./GameLoader.vue?vue&type=template&id=48aa1098&scoped=true&ts=true"
import script from "./GameLoader.vue?vue&type=script&lang=ts"
export * from "./GameLoader.vue?vue&type=script&lang=ts"

import "./GameLoader.vue?vue&type=style&index=0&id=48aa1098&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48aa1098"]])

export default __exports__